var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45l10 10 10-10v25H30V45z",
    fill: "url(#paint0_linear_1288_31960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.998 38.334c-8.284 0-15-6.716-15-15 0-8.284 6.715-15 15-15 8.284 0 15 6.716 15 15 0 8.285-6.716 15-15 15z",
    fill: "url(#paint1_linear_1288_31960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.166 38.334l3.333 3.333 3.334-3.334L67.499 35l-3.333 3.334zm-47.5-31.667l2.5 2.5 2.5-2.5-2.5-2.5-2.5 2.5zm-10 24.166L8.333 32.5l1.666-1.667-1.666-1.666-1.667 1.666z",
    fill: "#76808F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-6.667C15.97 45 10 50.97 10 58.333V70h20V45z",
    fill: "url(#paint2_linear_1288_31960)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h20V58.333C70 50.97 64.03 45 56.667 45H50v25z",
    fill: "url(#paint3_linear_1288_31960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_31960",
    x1: 40,
    y1: 70,
    x2: 40,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_31960",
    x1: 39.998,
    y1: 38.334,
    x2: 39.998,
    y2: 8.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1288_31960",
    x1: 40,
    y1: 45,
    x2: 40,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1288_31960",
    x1: 40,
    y1: 45,
    x2: 40,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e12b16303b00818357d4635b02645456.svg";
export { ForwardRef as ReactComponent };